import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isNullOrUndefined, isEmptyString } from "base/utils";
import React, { useEffect, useRef, useState } from "react";

const RecipeSearchByName = ({ recipes, onSearch, closeMenu }) => {
  const [searchInput, setSearchInput] = useState("");
  const [buttonWidth, setButtonWidth] = useState(0);
  const buttonRef = useRef(null);

  const handleChange = (e) => {
    setSearchInput(e.target.value);
    const filteredRecipes = recipes.filter((recipe) => {
      return recipe.recipe_name
        .toLowerCase()
        .includes(searchInput.toLowerCase());
    });
    onSearch(filteredRecipes);
  };

  const clearSearch = () => {
    setSearchInput("");
    onSearch(recipes);
  };

  // Measure button width once after mount
  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  return (
    <div>
      <input
        id="Recipe-Search"
        style={{ marginLeft: buttonWidth }}
        className="Search-By-Name"
        type="search"
        placeholder="Search recipes by name"
        value={searchInput}
        onChange={handleChange}
      />
      {!isNullOrUndefined(searchInput) && !isEmptyString(searchInput) && (
        <button id="clear-text-field" type="button" onClick={clearSearch}>
          <FontAwesomeIcon className="fa-thin" icon={faXmark} />
        </button>
      )}
      <button
        ref={buttonRef}
        id="searchIcon"
        className="faking"
        onClick={closeMenu}
      >
        <FontAwesomeIcon className="fa-thin" icon={faMagnifyingGlass} />
      </button>
    </div>
  );
};

export default RecipeSearchByName;
